module.exports = __webpack_public_path__ + "img/icb-empty-Inte-m@2x.ad876895.png";